import { Link, useLocation } from 'react-router';
import { cn } from '@/lib/utils';

export function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  const location = useLocation();
  const isActive = location.pathname === to || (to !== '/' && location.pathname.startsWith(to));

  return (
    <Link
      to={to}
      className={cn(
        'px-3 py-2 sm:px-4 min-h-[44px] inline-flex items-center rounded-md text-sm font-medium whitespace-nowrap shrink-0 snap-start transition-colors',
        isActive
          ? 'bg-primary text-primary-foreground'
          : 'text-muted-foreground hover:text-foreground hover:bg-muted'
      )}
    >
      {children}
    </Link>
  );
}
